<template>
  <SectionKvBannerSingle01
    :breadcrumbs="breadcrumbs"
    :title="t('title')"
    :description="description"
    :description-html="descriptionHtml"
    :button01="button01"
    :thumbnail="thumbnail"
    theme="cyan"
  />
</template>

<script setup lang="ts">
  import type { IButton } from '@/components/Shared/Section/KvBanner/Single01.vue';

  const { t, locale } = useI18n({ useScope: 'local' });
  const { t: tGlobal } = useI18n({ useScope: 'global' });
  const { blobDomain } = useWebsite();
  const { provideResponsiveImgName } = useImagePath();

  const breadcrumbs = computed((): string[] => [
    tGlobal('breadcrumb.home'),
    tGlobal('breadcrumb.topics'),
  ]);

  const description = computed((): string =>
    t('description').replace(/\[\[|\]\]/g, '')
  );

  const descriptionHtml = computed((): string =>
    t('description').replace(
      /\[\[(.+?)\]\]/g,
      '<span class="font-bold text-brand-400">$1</span>'
    )
  );

  const thumbnail = computed(
    (): string =>
      `${blobDomain.value}/wise-paas-marketplace/topics2/doe/${provideResponsiveImgName('banner')}`
  );

  const button01 = computed(
    (): IButton => ({
      text: t('item-button'),
      link: `/${locale.value}/marketplace/help/sales-support?IssueType=1`,
    })
  );
</script>

<i18n lang="json">
{
  "en-int": {
    "title": "AI-Powered Digital O&M",
    "description": "Advantech WISE Connects Site Data for [[Remote Operations, Multi-Site Visibility, and AI-Driven Optimization]]—Helping Energy and Utilities Operate More Reliably and Efficiently.",
    "item-button": "Talk to an Expert"
  },
  "en-jp": {
    "title": "AI-Powered Digital O&M",
    "description": "Advantech WISE Connects Site Data for [[Remote Operations, Multi-Site Visibility, and AI-Driven Optimization]]—Helping Energy and Utilities Operate More Reliably and Efficiently.",
    "item-button": "Talk to an Expert"
  },
  "en-tw": {
    "title": "AI-Powered Digital O&M",
    "description": "Advantech WISE Connects Site Data for [[Remote Operations, Multi-Site Visibility, and AI-Driven Optimization]]—Helping Energy and Utilities Operate More Reliably and Efficiently.",
    "item-button": "Talk to an Expert"
  },
  "en-kr": {
    "title": "AI-Powered Digital O&M",
    "description": "Advantech WISE Connects Site Data for [[Remote Operations, Multi-Site Visibility, and AI-Driven Optimization]]—Helping Energy and Utilities Operate More Reliably and Efficiently.",
    "item-button": "Talk to an Expert"
  },
  "en-americas": {
    "title": "AI-Powered Digital O&M",
    "description": "Advantech WISE Connects Site Data for [[Remote Operations, Multi-Site Visibility, and AI-Driven Optimization]]—Helping Energy and Utilities Operate More Reliably and Efficiently.",
    "item-button": "Talk to an Expert"
  },
  "en-asia-pacific": {
    "title": "AI-Powered Digital O&M",
    "description": "Advantech WISE Connects Site Data for [[Remote Operations, Multi-Site Visibility, and AI-Driven Optimization]]—Helping Energy and Utilities Operate More Reliably and Efficiently.",
    "item-button": "Talk to an Expert"
  },
  "en-emea": {
    "title": "AI-Powered Digital O&M",
    "description": "Advantech WISE Connects Site Data for [[Remote Operations, Multi-Site Visibility, and AI-Driven Optimization]]—Helping Energy and Utilities Operate More Reliably and Efficiently.",
    "item-button": "Talk to an Expert"
  },
  "ja-jp": {
    "title": "デジタル維持管理（O&M）",
    "description": "Advantech WISEは、現場・設備データを統合し、[[遠隔運用や複数拠点の可視化、AIによる最適化]]を実現。エネルギー・ユーティリティ企業の安定運用と効率向上を支援します。",
    "item-button": "専門家に相談する"
  },
  "zh-tw": {
    "title": "數位維運（O&M）",
    "description": "Advantech WISE 整合現場數據，實現[[遠端監控、跨據點統一可視化及 AI 智慧優化]]，協助能源與公用事業提升營運效率與穩定性",
    "item-button": "諮詢我們的專家"
  }
}
</i18n>
